
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.513 14.068h.117c.116 0 .184-.725.184-.725l2.208.488v-.363a.276.276 0 00-.135-.287l-1.836-1.173.246-1.142v-.542l.041-2.607h1.719l4.269 1.344.165.309s.072-.744-.197-.896c-.268-.152-3.999-2.078-3.999-2.078V4.949s.049-.147-.135-.147h-.694l-.014-.001a.203.203 0 00-.201.202v.014c0 .223.072.895.072.895l-.896-.448a.746.746 0 01-.148-.564V3.135s.157-1.791-.761-2.203h-.036c-.896.416-.761 2.203-.761 2.203V4.9a.746.746 0 01-.148.564l-.896.448s.072-.663.072-.895v-.014a.203.203 0 00-.201-.202l-.014.001H4.84c-.184 0-.135.147-.135.147v1.447S.974 8.313.706 8.474c-.269.161-.197.896-.197.896l.165-.309 4.269-1.344h1.719l.041 2.607v.542l.246 1.142-1.836 1.173a.276.276 0 00-.135.287v.363l2.208-.488s.063.725.184.725h.143z"}})])
          )
        }
      }
    